module.exports = __webpack_public_path__ + "media/Do.05c43de3.wav";